import { AfterViewChecked, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[ellipsize]',
})
export class EllipsizeDirective implements AfterViewChecked {
  @Input() private maxChars;
  private el: HTMLElement;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  public ngAfterViewChecked() {
    let text = this.el.innerText;
    if (this.maxChars) text = text.slice(0, this.maxChars);
    while (this.el.scrollHeight > this.el.offsetHeight) {
      text = text.slice(0, text.lastIndexOf(' '));
      this.el.innerText = text + '...';
    }
  }
}
